import { themeVars } from '@coverflex-tech/hypernova';
import { style } from '@vanilla-extract/css';

const root = style({
  width: '100%',
  padding: themeVars.spacing.md,
  borderTop: `0.1rem solid ${themeVars.color.semantic.surface.neutral30}`,
});

export const css = {
  root,
};
